import React from 'react';

export default () => (
    <div className="big-balls">
        <div className="white-gray-ball">
            <div className="ball"></div>
        </div>
        <div className="orange-medium-ball">
            <div className="ball"></div>
        </div>
        <div className="blue-and-red-big-ball">
            <div className="ball"></div>
        </div>
        <div className="giper-white-ball">
            <div className="ball"></div>
        </div>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/Commons/Balls.js